<nav class="navbar bg-flats-white b-b-border-main">
  <svg-icon
    src="assets/images/aptem-assess-logo.svg"
    data-ua-id="navbar-logo"
  ></svg-icon>
</nav>
